/*
 *
 * ForgotPasswordPage Form
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  getFormSyncErrors,
} from 'redux-form';
import { createStructuredSelector } from "reselect";
import {
  StyledForm,
  ButtonGroup,
} from './styledComponents';
import validate from './validate';
import { selectHasRpsPasswordError } from "./selectors";

import Button from 'components/Button';
import InputField from 'components/InputField';

const Form = ({
  handleSubmit,
  pristine,
  submitting,
  syncErrors,
  openInvalidPasswordModal,
  openPasswordRequirementsModal,
  resetToken,
  hasRpsPasswordError,
}) => (
  <StyledForm onSubmit={handleSubmit}>
    <Field
      name="password"
      type="password"
      component={InputField}
      label="New Password"
      placeholder="••••••••••••"
      showPasswordButton={false}
      helpIcon={true}
      helpEvent={openPasswordRequirementsModal}
      isSignup
    />
    <Field
      name="password_confirmation"
      type="password"
      component={InputField}
      label="Repeat New Password"
      placeholder="••••••••••••"
      showPasswordButton={false}
      helpIcon={true}
      helpEvent={openPasswordRequirementsModal}
      isSignup
    />
    <Field
      name="reset_password_token"
      value={resetToken}
      component={(props) => <input {...props.input} hidden />}
    />
    <ButtonGroup>
      {hasRpsPasswordError ? (
        <Button
          type="submit"
          onClick={() => openInvalidPasswordModal()}
        >
          Confirm New Password
        </Button>
      ) : (
        <Button type="submit" disabled={submitting}>
          Confirm New Password
        </Button>
      )}
    </ButtonGroup>
  </StyledForm>
);

const mapStateToProps = createStructuredSelector({
  hasRpsPasswordError: selectHasRpsPasswordError(),
  syncErrors: getFormSyncErrors("forgotPasswordForm"),
});

export default connect(mapStateToProps)(
  reduxForm({ form: "forgotPassword" })(Form)
);



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/Form.js